import { Injectable } from '@angular/core'
import { PageLayoutHandler } from '@spartacus/storefront'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { EbAuthService } from '../../auth/services/eb-auth.service'

@Injectable()
export class EbPartnerSlotLayoutHandler implements PageLayoutHandler {
  constructor(protected authService: EbAuthService) {}

  handle(slots$: Observable<string[]>, pageTemplate, section): Observable<string[]> {
    return combineLatest([slots$, this.authService.isUserLoggedIn()]).pipe(
      map(([slots, isUserLoggedIn]) => {
        if (isUserLoggedIn && /Template$/.test(pageTemplate) && !section) {
          return [...slots, 'Partners']
        } else {
          return slots
        }
      })
    )
  }
}
